var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-avatar',_vm._b({},'v-avatar',_vm.$attrs,false),[_c('img',{attrs:{"src":_vm.channelTypeAvatar}})])}
var staticRenderFns = []

export { render, staticRenderFns }